/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monsterplanlabel7d2Inputs */



/**
* | output |
* | --- |
* | "1 week" |
*
* @param {Monsterplanlabel7d2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const monsterplanlabel7d2 = /** @type {((inputs?: Monsterplanlabel7d2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monsterplanlabel7d2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("1 week")
	if (locale === "es") return /** @type {LocalizedString} */ ("1 semana")
	return /** @type {LocalizedString} */ ("1 неделя")
});
export { monsterplanlabel7d2 as "monsterPlanLabel7d" }